<!-- TODO: this should get new feedback when a feedback is submitted -->
<div
  *ngIf="approvalDetails.length > 0"
  class="flex justify-start gap-[50px] w-[100%] !mb-[70px]"
>
  <!-- Left Column -->
  <div class="w-[29%] p-[30px] flex-col">
    <h3 class="section-headers">Approval Status</h3>

    <p
      class="requested-field !mb-[34px]"
      [ngClass]="
        approvalStatus?.status === APPROVAL_STATUS?.Pending
          ? 'text-[#F4AB23]'
          : 'text-[#197741]'
      "
    >
      {{ approvalStatus?.status }}
    </p>
    <p class="requested-field !mb-[34px]">Date Requested</p>
    <p class="requested-field !mb-[34px]">
      {{ approvalDetails[0]?.createdAt | date : "MM/dd/YYYY" }}
    </p>

    <ng-container *ngIf="isUserApprover()">
      <button
        class="bg-[#E76B3F] text-white font-bold-[500] !text-[20px] !p-[16px] rounded-[4px] flex items-center space-x-2"
        (click)="openApprovalFeedbackDialog()"
      >
        <mat-icon class="text-lg">rate_review</mat-icon>
        <span>Review</span>
      </button>
    </ng-container>
  </div>

  <!-- Right Column -->
  <div class="flex-1 flex flex-col items-start justify-start mt-[30px]">
    <h4 class="section-headers">Sender Note</h4>
    <p [innerHTML]="approvalStatus?.senderNote" class="text-gray-700 mb-2"></p>
    <div class="space-y-4">
      <div *ngIf="approvalDetails.length > 0">
        <p
          class="text-gray-500 pb-[1.5rem]"
          [innerHTML]="getSanitizedString(approvalDetails[0]?.note)"
        ></p>
        <div *ngFor="let approval of approvalDetails">
          <p class="font-bold !mb-0">{{ approval.userName }}</p>
          <p class="text-sm text-gray-500 !mb-0">{{ approval?.userTitle }}</p>
          <p
            class="text-sm !mb-0 font-bold"
            [ngClass]="{
              'text-[#F4AB23]': approval?.status === APPROVAL_STATUS?.Pending,
              'text-[#197741]': approval?.status === APPROVAL_STATUS?.Approved,
              'text-[#FF0000]': approval?.status === APPROVAL_STATUS?.Rejected
            }"
          >
            {{ approval?.status | replaceDashAndSentenceCase }}
          </p>
          <p class="text-sm text-gray-500 !mb-0">
            {{ approval?.statusUpdatedAt }}
          </p>
          <p
            *ngIf="approval.feedback; else noFeedback"
            [innerHTML]="getSanitizedString(approval.feedback)"
          ></p>
          <ng-template #noFeedback>No feedback yet</ng-template>
        </div>
      </div>
      <div *ngIf="approvalDetails.length === 0">
        <p>No approvals to show.</p>
      </div>
    </div>
  </div>
</div>
